var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItang(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.71326 0.296707C3.56248 0.447483 3.47012 0.657009 3.47042 0.887113L3.47042 0.988391C3.47042 1.44919 3.84346 1.82223 4.30366 1.82164L8.85658 1.82164L1.15483 9.52339C0.82956 9.84866 0.82956 10.3766 1.15483 10.7019C1.4801 11.0272 2.00807 11.0272 2.33334 10.7019L10.0351 3.00015V7.55307C10.0351 8.01387 10.4081 8.3869 10.8683 8.38631H10.9696C11.4304 8.38631 11.8035 8.01328 11.8029 7.55307V0.887114C11.8029 0.426316 11.4298 0.05328 10.9696 0.0538691L4.30366 0.0538688C4.07326 0.0538691 3.86403 0.145931 3.71326 0.296707Z",
    fill: "#34C759"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItang);
export default __webpack_public_path__ + "static/media/itang.88dd95b478c77afb752fbaeb4226b5f6.svg";
export { ForwardRef as ReactComponent };